<template>
  <v-content class="esh-theme">
    <v-toolbar height="22">
      <v-toolbar-items>
        <v-btn
          v-for="(item, idx) in items"
          :key="idx"
          :to="{ name: item.name }"
        >{{ item.meta.label || '' }}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-container fluid>
      <router-view></router-view>
    </v-container>
  </v-content>
</template>

<script>
import MunicipalityRoutes from '@/router/municipality'

export default {
  name: 'MunicipalityIndex',
  data() {
    return {}
  },
  computed: {
    items() {
      return MunicipalityRoutes.children.filter(item => item.path !== '')
    }
  }
}
</script>
